import React from 'react';
import CsvParse from 'papaparse';
import { UploadFileStep } from './steps/UploadFileStep';
import { ReviewStep } from './steps/ReviewStep';
import { DeactivatedStep } from './steps/DeactivatedStep';
import { useEndpointFetch } from '../../../global/network/useEndpointFetch';

type VolunteerDeactivateType = {
  email: string;
};

export function DeactivateVolunteersScreen() {
  const [step, setStep] = React.useState<number>(0);
  const [uploadingFile, setUploadingFile] = React.useState<File>();
  const [fileData, setFileData] = React.useState<any>([]);
  const [deactivatedData, setDeactivatedData] = React.useState<any>();
  const [isDeactivating, setIsDeactivating] = React.useState(false);

  const onNext = () => setStep((currentStep) => currentStep + 1);
  const onBack = () => setStep((currentStep) => Math.max(0, currentStep - 1));

  const deactivateVolunteers = useEndpointFetch<{ volunteers: VolunteerDeactivateType[] }, any>(
    '/vm/volunteer/deactivate-bulk'
  );

  const onDeactivate = (volunteers: any) => {
    setIsDeactivating(true);
    onNext();
    deactivateVolunteers
      .run({
        volunteers,
      })
      .then((response) => {
        setDeactivatedData(response);
        setIsDeactivating(false);
      })
      .catch(() => {
        setIsDeactivating(false);
      });
  };

  React.useEffect(() => {
    if (!uploadingFile) {
      return;
    }
    CsvParse.parse(uploadingFile, {
      header: true,
      skipEmptyLines: true,
      complete: (csvData: any) => {
        setFileData(csvData.data);
      },
    });
  }, [uploadingFile]);

  switch (step) {
    case 0:
      return <UploadFileStep onNext={onNext} onUpload={setUploadingFile} uploadingFile={uploadingFile} />;

    case 1:
      return (
        <ReviewStep
          onDeactivate={onDeactivate}
          onBack={onBack}
          data={fileData}
          setData={setFileData}
          isDeactivating={isDeactivating}
        />
      );

    case 2:
      return (
        <DeactivatedStep
          data={deactivatedData?.data?.data}
          onBack={() => setStep(1)}
          onComplete={() => setStep(0)}
          isDeactivating={isDeactivating}
        />
      );
    default:
      return null;
  }
}
